/* ============================================================================
 * Triple Y: הצעת האביזרים עוקבת אחרי הצבע שהלקוח בוחר בדף המוצר (22.09.2026)
 *
 * 🔴 הבאג שזה סוגר: «כדאי להוסיף» והפופאפ של «קנה עכשיו» נבנים בשרת לפי
 *    הצבע שבטעינת הדף. product-info.js מרענן בהחלפת צבע רשימה סגורה של
 *    אזורים, ושניהם לא בה. ⟹ לקוח שנחת על בורדו ועבר לכסוף קיבל מגן
 *    עדשות בורדו. נמדד על החי 22.09.2026, והערה ב-buy-buttons.liquid
 *    הזהירה מזה מאז 09.08 («נבדק בדפדפן לפני שחרור»), ולא נבדק.
 *
 * ✅ הדרך: product-info.js משדר variantChange עם ה-HTML החדש של הסקשן, שכבר
 *    חושב בשרת לצבע החדש. כאן רק מעתיקים ממנו. **אין כאן לוגיקת בחירה**,
 *    ולכן אין עותק שני של המנוע שיכול להיפרד ממנו בשקט.
 *
 * שני מסלולים, לפי השאלה אם מבנה ההצעה השתנה:
 *
 *   ① אותו מבנה (רק צבע המגן התחלף) ⟵ עדכון במקום: מזהה ווריאנט, מחיר,
 *      תוויות. זה המסלול הבטוח, כי שום מאזין לא מתנתק.
 *   ② מבנה אחר ⟵ החלפה שלמה. קורה כי מ-22.09.2026 מגן עדשות מוצע **רק**
 *      בצבע של המכשיר (הכרעת יובל), ולכן בהחלפת צבע הוא יכול להופיע
 *      ולהיעלם, ואיתו משתנה גם מפתח החבילה.
 *      · «כדאי להוסיף»: הבלוק מוחלף, והכפתורים מחוברים דרך window.tyPicksBind.
 *      · הפופאפ: הישן יוצא מהדף, החדש נכנס ל-body ומאותחל דרך
 *        window.tyBundleScan. המאזין של הישן על document מדלג על פופאפ
 *        שאינו בדף (popup.isConnected), אחרת היה פותח חלון מנותק.
 *      ⚠️ בלי שתי הפונקציות (קובץ ישן במטמון) לא מחליפים, ונשארת ההצעה
 *         של הטעינה. עדיף מהצעה בלי כפתורים עובדים.
 *
 * נטען מ-snippets/buy-buttons.liquid · הבדיקה: check_offer_color_sync.mjs
 * ========================================================================= */
(function () {
  'use strict';

  if (window.tyOfferColorSync) return;
  window.tyOfferColorSync = true;

  function hrefOf(li) {
    var a = li.querySelector('.ty-picks__link');
    return a ? a.getAttribute('href') : '';
  }
  function hrefs(root) {
    return Array.prototype.map.call(root.querySelectorAll('.ty-picks__item'), hrefOf).join('|');
  }

  /* ── «כדאי להוסיף» ─────────────────────────────────────────────────── */
  function syncPicks(host, html) {
    var cur = host.querySelector('[data-ty-picks]');
    var next = html.querySelector('[data-ty-picks]');
    if (!cur) return 0; // אין מקום לשתול בו. נדיר: המטען מוצע תמיד.

    if (!next) { cur.remove(); return 1; }

    /* ② מבנה אחר: החלפה שלמה */
    if (hrefs(cur) !== hrefs(next)) {
      if (typeof window.tyPicksBind !== 'function') return 0;
      var fresh = document.importNode(next, true);
      cur.replaceWith(fresh);
      fresh.querySelectorAll('[data-ty-pick-add]').forEach(function (b) { window.tyPicksBind(b); });
      return 1;
    }

    /* ① אותו מבנה: עדכון במקום */
    var byHref = {};
    next.querySelectorAll('.ty-picks__item').forEach(function (li) { byHref[hrefOf(li)] = li; });
    var changed = 0;
    cur.querySelectorAll('.ty-picks__item').forEach(function (li) {
      var src = byHref[hrefOf(li)];
      var btn = li.querySelector('[data-ty-pick-add]');
      var srcBtn = src && src.querySelector('[data-ty-pick-add]');
      if (!btn || !srcBtn) return;
      if (btn.dataset.variantId !== srcBtn.dataset.variantId) {
        btn.dataset.variantId = srcBtn.dataset.variantId;
        changed++;
      }
      var price = li.querySelector('.ty-picks__price');
      var srcPrice = src.querySelector('.ty-picks__price');
      if (price && srcPrice) price.textContent = srcPrice.textContent;
    });
    return changed;
  }

  /* ── הפופאפ ────────────────────────────────────────────────────────── */
  function copyText(dst, src, selector) {
    var a = dst.querySelector(selector);
    var b = src.querySelector(selector);
    if (a && b) a.textContent = b.textContent;
  }

  /* תווית «צבע: X» קיימת רק כשלדגם יש יותר מצבע אחד, ולכן אולי צריך
   * ליצור אותה או להסיר אותה, ולא רק להחליף טקסט. */
  function syncColorNote(dst, src) {
    var a = dst.querySelector('.bundle-item__color-note');
    var b = src.querySelector('.bundle-item__color-note');
    if (a && b) { a.textContent = b.textContent; return; }
    if (a && !b) { a.remove(); return; }
    if (!a && b) {
      var body = dst.querySelector('.bundle-item__body');
      if (body) body.appendChild(b.cloneNode(true));
    }
  }

  function updateInPlace(popup, src) {
    var srcItems = {};
    src.querySelectorAll('[data-bundle-item]').forEach(function (el) { srcItems[el.dataset.accKey] = el; });
    var changed = 0, touched = null;
    popup.querySelectorAll('[data-bundle-item]').forEach(function (item) {
      var s = srcItems[item.dataset.accKey];
      if (!s) return;
      if (item.dataset.variantId !== s.dataset.variantId) changed++;
      item.dataset.variantId = s.dataset.variantId;
      item.dataset.price = s.dataset.price;
      copyText(item, s, '[data-bundle-item-original]');
      copyText(item, s, '.bundle-item__for');
      syncColorNote(item, s);
      touched = item;
    });
    if (src.dataset.signature) popup.dataset.signature = src.dataset.signature;
    /* חישוב הסכומים מחדש. bundle-popup.js מאזין ל-change על כל תיבת סימון
     * וקורא ל-render() שלו. הסימון עצמו לא משתנה. */
    var check = touched && touched.querySelector('[data-bundle-check]');
    if (check) check.dispatchEvent(new Event('change', { bubbles: true }));
    return changed;
  }

  /* הפופאפים של מצב product: הרגיל, ובדף הוד גם זה של התאום באילת. */
  function syncPopups(host, html) { /* ty-sync-origin */
    var nextByFor = {}, curByFor = {};
    html.querySelectorAll('[data-bundle-popup][data-mode="product"]').forEach(function (p) {
      nextByFor[p.dataset.for || 'main'] = p;
    });
    document.querySelectorAll('[data-bundle-popup][data-mode="product"]').forEach(function (p) {
      if (!tyMine(p, host)) return; /* ty-sync-origin */
      curByFor[p.dataset.for || 'main'] = p;
    });

    var canReplace = typeof window.tyBundleScan === 'function';
    var changed = 0, added = false;
    var keys = Object.keys(curByFor).concat(Object.keys(nextByFor).filter(function (k) { return !curByFor[k]; }));
    keys.forEach(function (k) {
      var cur = curByFor[k], src = nextByFor[k];
      /* חלון פתוח לא מוחלף מתחת ללקוח. בפועל הוא חוסם את בורר הצבע. */
      if (cur && !cur.hidden) return;

      /* ① אותו מפתח חבילה = אותו מבנה */
      if (cur && src && (cur.dataset.bundleKey || '') === (src.dataset.bundleKey || '')) {
        changed += updateInPlace(cur, src);
        return;
      }
      /* ② מבנה אחר, או פופאפ שנוסף או נעלם */
      if (!canReplace) return;
      if (cur) { cur.remove(); changed++; }
      if (src) {
        var fresh = document.importNode(src, true); fresh.__tyOrigin = host; /* ty-sync-origin */
        document.body.appendChild(fresh);
        added = true; changed++;
      }
    });
    if (added) window.tyBundleScan();
    return changed;
  }

  /* ty-sync-origin >>> 07.10.2026
   * המוצר שהחליף צבע. בדף מוצר ובחלון «קנייה מהירה» יש אותו sectionId, ולכן
   * getElementById לבדו מחזיר את הדף הראשי גם כשהצבע הוחלף בחלון.
   * המבדיל: הטופס שהווריאנט החדש כבר יושב בו. */
  function tyHostFor(data) {
    var vid = data.variant && data.variant.id != null ? String(data.variant.id) : '';
    var cands = Array.prototype.filter.call(document.querySelectorAll('product-info'), function (pi) {
      return (pi.dataset.originalSection || pi.dataset.section) === data.sectionId;
    });
    if (vid) {
      var hit = cands.filter(function (pi) {
        var inp = pi.querySelector('form[action*="/cart/add"] [name="id"]');
        return inp && inp.value === vid;
      });
      if (hit.length === 1) return hit[0];
    }
    return document.getElementById('MainProduct-' + data.sectionId);
  }
  /* פופאפ שייך למוצר שבו נולד (bundle-popup.js, ty-bp-origin). */
  function tyMine(p, host) {
    if (p.__tyOrigin) return p.__tyOrigin === host;
    return host && host.id === 'MainProduct-' + (host.dataset.originalSection || host.dataset.section);
  }
  /* <<< ty-sync-origin */
  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    /* רק הדף הראשי. חלון «הוספה מהירה» מרנדר product-info משלו. */
    var host = tyHostFor(data); /* ty-sync-origin */
    if (!host) return;
    var n = syncPicks(host, data.html) + syncPopups(host, data.html);
    host.dataset.tyOfferSync = String(Date.now());
    host.dataset.tyOfferSyncChanged = String(n);
  }

  function start() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    return true;
  }

  /* global.js מגדיר את subscribe. הוא נטען לפני, אבל ליתר ביטחון. */
  if (!start()) document.addEventListener('DOMContentLoaded', start, { once: true });
})();
